//Junais 08-Dec-2022
import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import CustomeMessageModal from './CustomeMessageModal';
import * as appActions from '../actions/appactions'
import * as userActions from '../modules/userprofile/actions/userprofileactions'
import * as appConstants from '../overrides/appconstants'
export default function AppMessage() {
    const appReducerState = useSelector((state) => state.appReducer);

    const dispatch = useDispatch();

    function onButtonClick(button) {
        dispatch(appActions.closeMessage());
        appReducerState.messageCallback(button);

    }
    function onRequestClose() {
        dispatch(appActions.closeMessage());
    }

    function renderButtons() {
        let buttons = [];
        if (appReducerState.messageOptions != undefined && appReducerState.messageOptions.buttons != undefined) {
            buttons = appReducerState.messageOptions.buttons;
        } else {
            buttons.push('OK');
        }
        return buttons.map(buttonText => {
            return (

                <button className={buttonText === "Close" ? 'btn btn-danger' : 'btn btn-success'} style={{ marginLeft: '10px' }} key={buttonText} onClick={() => onButtonClick(buttonText)}>
                   {buttonText} {buttonText === "Close" ? <i className="dripicons-cross"></i> : <i className="dripicons-checkmark"></i>}
                </button>

            );
        });
    }
    let hasMessage = appReducerState.message != '';
    return (

        <CustomeMessageModal
            isOpen={hasMessage} zIndex="100000000" onRequestClose={onRequestClose}>



            <div class="mb-3">

                <blockquote class="blockquote">
                    <p class="mb-0">{appReducerState.message}</p>
                </blockquote>


                {renderButtons()}
            </div>


        </CustomeMessageModal>
    )

}

